import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { GET_JMS_DETAILS, SUBMIT_JMS_DATA, GET_JMS_LIST } from './type';

export const getJmsDetails = (data) => async (dispatch) => {
  try {
    const url = `${Config.jms.jmsPoDetails}?site_id=${data.site_id}${data.jms_id ? `&jms_id=${data.jms_id}` : ''}`;
    const res = await callWebService(
      callTypes.get,
      '',
      url 
    );
    if (res?.data) {
      dispatch({
        type: GET_JMS_DETAILS,
        payload: res.data.data || res.data.response || {},
      });
    }
    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in getJmsDetails:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};

export const submitJmsData = (data) => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.jms.submitJmsDetails
    );
    if (res?.data) {
      dispatch({
        type: SUBMIT_JMS_DATA,
        payload: res.data.response || {},
      });
    }
    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in submitJmsData:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};

export const getJmsList = (page) => async (dispatch) => {
  try {
    const url = `${Config.jms.getJmsListing}?page=${page}`;
    const res = await callWebService(
      callTypes.get,
      '',
      url
    );
    if (res?.data) {
      dispatch({
        type: GET_JMS_LIST,
        payload: res.data.data || res.data.response || {},
      });
    }
    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in getJmsList:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};

export const approveJmsData = (data) => async () => {
  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.jms.approveJmsDetails
    );
    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error in approveJmsData:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }
};
